import TitleComponent from "components/TitleComponent";
import { TooltipComponent } from "components/toolTipComponent/TooltipComponent";
import { STARTPAGETITLES } from "InterfacesTypes/enums";
import type { ILatestUpdatedPages } from "InterfacesTypes/interfaces";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectRecentlyUpdatedPages, selectTitleTexts } from "state/selectors/Selectors";

const RecentlyUpdatedPages = () => {
  const updatedPages: ILatestUpdatedPages[] = useSelector(selectRecentlyUpdatedPages);
  const latestFivePages: ILatestUpdatedPages[] = updatedPages.slice(0, 5); // the first 5  objects are the latest pages, they are already sorted in the right order
  const titleTexts = useSelector(selectTitleTexts);
  const recentUpdatedPagesTitle = titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.RECENT_UPDATED_PAGES_START_PAGE_TITLE);

  return (
    <>
      {recentUpdatedPagesTitle?.Description ?
        <TooltipComponent
          tooltipClassName="!w-full !max-w-full"
          className="w-full"
          content={recentUpdatedPagesTitle?.Description}
        >
          <div>
            <TitleComponent title={recentUpdatedPagesTitle?.Title ?? "Titel saknas"} />
          </div>
        </TooltipComponent>
        :
        <div>
          <TitleComponent title={recentUpdatedPagesTitle?.Title ?? "Titel saknas"} />
        </div>
      }
      <ul className="!px-3 !mt-6">
        {latestFivePages.map((page, i) => (
          <li
            key={i}
            className=" hover:scale-105 transition-transform duration-600"
          >
            <a
              href={page.OriginalPath}
              className="flex items-start hover:bg-gray-50 !rounded-lg  transition !no-underline "
            >
              <div className="!min-w-0 flex-1">
                <p className="!text-[18px] text-start font-semibold !text-[rgb(44,43,43)] leading-snug line-clamp-2 hover:!underline">
                  {page.Title}
                </p>
              </div>
            </a>
          </li>
        ))}
        <li className="flex justify-self-end !mr-4 !mb-2 hover:scale-105 transition-transform duration-600 border-none!">
          <Link className="border-none! hover:bg-transparent! no-underline!" to={"/recentfiles/pages"}>Visa fler sidor...</Link>
        </li>

        {/* <li className="flex justify-self-end !mr-4 !mb-2 hover:scale-105 transition-transform duration-600">
          Läs mer...
        </li> */}
      </ul>
    </>
  );
};
export default RecentlyUpdatedPages;
